<!-- Full-screen popup *ngIf="showSuccessPopup" -->
<div class="popup-success" *ngIf="showSuccessPopup">
  <div class="popup-content mbb">
    <!--    
    <div class="circle-img">
      <img src="assets/papay1.jpeg" alt="Product">
    </div>

   
    <div class="success-title text-muted">Order successfully placed</div>
    <div class="order-number text-muted">Order Number : T2010SK6</div>

  
    <div class="genuine-text">
      <i class="bi bi-shield-check"></i> Yay! This is a genuine product
    </div>

   
    <div class="login-text text-muted">Please login to check the product details.</div>

    
    <a (click)="ShowLogin()" class="login-link">&larr; Login</a> -->

    <!-- Product Image in Circle -->
    <div class="circle-img mt-1">
      <img src="assets/papay1.jpeg" alt="Product">
    </div>

    <!-- Success Text -->
    <div class="success-title mt-3">Order successfully placed</div>
    <div class="order-number">Order Number : {{ppcode}}</div>

    <!-- Genuine Product Message -->
    <div class="genuine-text mt-3">
      <i class="bi bi-check-circle mt-3"></i> Yay! This is a genuine product
    </div>

    <!-- Info -->
    <div class="login-text mt-3">Please login to check the product details.</div>

    <!-- Login Link -->
    <a (click)="succeelogin()" class="login-link">&larr; Login</a>

    <!-- Bootstrap Icons -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
  </div>
</div>

<!-- *ngIf="Isregistered" -->
<div class="pt-55" *ngIf="Isregistered">
  <div class="sc aaa">

    <!-- <h3 class="text-center">
      <span class="fw-bold">Scanned Product Details</span>
    </h3>
    <div class="container mt-5">
      <div class="p-3 border-bottom">
        <img src="assets/logo.jpg" alt="Logo" height="40">
        <h4 class="fw-bold">Papaya Red Lady</h4>

      </div>

    
      <div class="custom-alert d-flex align-items-start mt-3  justify-content-center ">
        <span class="icon">&#10006;</span>
        <div>
          <p class="mb-1 fw-bold">
            This product item has already been sold and registered to another user.
          </p>
          <p class="mb-1">
            If you see this item on sale, most likely it is a counterfeit.
          </p>
          <p class="mb-0">
            Please help us protect buyers like yourself by reporting this incident.
          </p>
        </div>
      </div>
    </div> -->
    <div class="">

      <h5 class="text-center bg-secondary2 mt-4"><strong class="fs22">Scanned Product Details</strong> </h5>

      <div class="row justify-content-center text-center px-4">
        <!-- Logo and Heading -->
        <div class="pt-3 px-0 pb-0 pppp border-bottom" align="left">
          <img src="assets/papayy.jpeg" alt="Logo" height="30"><br>
          <h5 class="mt-2"><strong>Papaya Red Lady</strong></h5>
        </div>
        <div class="col-md-6">



          <!-- Alert Box with X on the left -->
          <div class="alert-custom row  text-center">
            <div class="icon mt-55 col-2"><i class="bi bi-x-lg"></i></div>
            <div class="col-10 py-3 border-start border-black1 dfs" style="text-align: start;">
              <span class="mb-1 fw-bold">
                This product item has already been sold and registered to another user. If you see this item on sale,
                most likely it is a counterfeit.
              </span><br>
              <span class="mb-1 fw-bold">
                Please help us protect buyers like yourself by reporting this incident.
              </span>
            </div>
          </div>

          <!-- Sign In Note -->
          <p class="mt-3 px-3 py-3 rounded signin  text-muted" align="left">
            If you have registered this product before, please <a href="" class="text-decoration-none">sign in</a> with
            the corresponding account.
          </p>

          <!-- Report Button -->
          <button class="report-btn mb-4 ">Report this incident</button>

          <!-- Powered by -->
          <div class="text-center mt-3 powered-by">
            <div> <span class="pb">Powered by</span></div>

            <img src="assets/dyblue-Photoroom.png" alt="Powered by DYRECT" style="max-height:18px;">
          </div>
          <!-- <div class="text-center mt-4 powered-by">
            <span class="pb" style="margin:0; padding:0;">Powered by</span>
            <img src="assets/dyblue.jpg" alt="Powered by DYRECT" style="max-height:30px; margin:0; padding:0;">
          </div> -->


        </div>
      </div>
    </div>

  </div>
</div>
<!-- *ngIf="Isloginpage" -->

<div class=" pt-55" *ngIf="Isloginpage">
  <div class=" sc">
    <div class="product-card">
      <!-- Header -->
      <!-- <div class="p-3 text-center border-bottom">
        <img src="assets/logo.jpg" alt="Logo" height="40">
        <h5 class="mt-2"><strong>Papaya Red Lady</strong> </h5>
      </div> -->


      <div class="container text-center bg-secondary1 mt-3">
        <span class="fw-bold fs22">Scanned Product Details</span>
      </div>

      <div class="p-3 border-bottom">
        <img src="assets/papayy.jpeg" alt="Logo" height="30">
        <div class="row">
          <div class="col-6">

          </div>
          <div class="col-6">
            <i class="bi bi-heart fs-5 me-2 ic"></i>
            <i class="bi bi-box-arrow-up fs-4 ic"></i>

          </div>
        </div>
        <h5 class="mt-2"><strong>Papaya Red Lady</strong></h5>
      </div>

      <!-- Auth Box -->
      <div class="row auth-box mx-3 rounded">
        <div
          class=" py-4  col-2 text-center d-flex justify-content-center align-items-center border-end border-secondary pe-0 fs-3">
          <!-- <i class="bi bi-check-lg fs-1 ms-4"></i> --><i class="fa-solid fa-check"></i>
        </div>

        <div class=" py-4  col-10">
          <div class="mb-1">
            AUTHENTIC
          </div>
          This product is registered to you

          <span class="au ">Authenticated by </span> <img src="assets/dy.png" alt="Logo" height="20">
        </div>
      </div>



      <!-- Product Details -->
      <div class="details row ps-0">
        <div class="col-6 ">
          <strong>Product Serial No.:</strong><br>
          <strong>Registered On:</strong>
        </div>

        <div class="col-6">
          <span>{{ppcode}}</span><br>
          <span>{{today| date: 'dd/MM/yyyy'}}</span>
        </div>
        <!-- <span><strong>Product Serial No.:</strong>{{ppcode}}</span><br>
        <span><strong>Registered On:</strong> {{today| date: 'dd/MM/yyyy'}}</span> -->
      </div>

      <!-- Image Slider -->
      <div id="productCarousel" class="carousel slide" data-bs-interval="false"
        style="margin-bottom:0; padding-bottom:0;">

        <!-- Indicators -->
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#productCarousel" data-bs-slide-to="0" class="active"></button>
          <button type="button" data-bs-target="#productCarousel" data-bs-slide-to="1"></button>
        </div>

        <!-- Slides -->
        <!-- <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="assets/papay1.jpeg" class="d-block w-100" alt="Papaya 1">
          </div>
          <div class="carousel-item">
            <img src="assets/img.jpeg" class="d-block w-100" alt="Papaya 2">
          </div>
        </div> -->

        <div id="carouselExample" class="carousel slide">
          <div class="carousel-inner">
            <div class="carousel-item active ">
              <img src="assets/papay2.jpg" class="d-block w-100 " alt="...">
            </div>
            <div class="carousel-item">
              <img src="assets/img.jpeg" class="d-block w-100 al" alt="...">
            </div>

          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>

        <!-- Controls -->
        <button class="carousel-control-prev" type="button" data-bs-target="#productCarousel" data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#productCarousel" data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>

      <!-- Additional Info -->
      <div class="product-info p-3 border-top">
        <h6 class="fs-4">Red Lady</h6>
        <p>Flesh color:Red</p>
        <p>Fruit weight: 1.5 – 2.0 kg</p>
        <p>Fruit shape:Long (Hermaphrodite) / Short oblong (Female)</p>
        <p>Brix: 13</p>
        <p>Vigorous, dwarf plant, high yield,<br>
          Very good shelf life and strong shipping ability.</p>
      </div>


      <!-- Footer Menu -->
      <!-- <div class="d-flex justify-content-around border-top p-2 bg-light">
    <a href="#" class="text-decoration-none text-dark"><i class="bi bi-heart"></i> My Favorites</a>
    <a href="#" class="text-decoration-none text-dark"><i class="bi bi-bag"></i> My Purchases</a>
    <a href="#" class="text-decoration-none text-dark"><i class="bi bi-person"></i> My Profile</a>
  </div>
</div> -->
    </div>
  </div>
</div>



<div *ngIf="isqrcode" class="mx-5  w-75 aaa1">
  <div class="container">
    <form class="row g-3">

      <div class="col-auto">
        <label for="inputPassword2" class="visually-hidden">Password</label>
        <input type="password" class="form-control" [(ngModel)]="QRPass" name="qrpass" id="inputPassword2"
          placeholder="Password">
      </div>
      <div class="col-auto">
        <button (click)="QrLogin()" class="btn btn-primary mb-3">Login</button>
      </div>
    </form>
  </div>
  <div class="container" *ngIf="isqrcodeispass">

    <h2 class="fw-bold text-primary"><i class="bi bi-qr-code"></i> Bulk QR Code Generator</h2>

    <div class="my-3">
      <label class="form-lable fw-bold mb-2" for=""><i class="bi bi-link-45deg"></i> URL</label>
      <input class="form-control" type="text" [(ngModel)]="URLBase">
    </div>
    <label class="form-lable fw-bold mb-2" for=""><i class="bi bi-chat-square-text"></i> Product Codes</label>
    <textarea class="form-control border border-secondary" [(ngModel)]="productCodesText" rows="6"
      placeholder="Enter product codes separated by comma or newline" style="width:100%; padding:10px;"></textarea>

    <div style="margin-top:10px;">
      <button (click)="generateQRCodes()">Generate QR Codes</button>
  
      <button (click)="downloadAllAsZip()" [disabled]="!qrData.length">Download All as ZIP</button>
      <button (click)="downloadPDF(true)" [disabled]="!qrData.length">PDF - All in One Page</button>
      <!-- <button (click)="downloadPDF(false)" [disabled]="!qrData.length">PDF - Separate Pages</button> -->
    </div>

    <div *ngFor="let qr of qrData" style="margin-top:20px;">
      <img [src]="qr.dataUrl" alt="QR Code" style="width:150px; height:150px;">
      <p>{{ baseUrl + qr.code }}</p>
      <button (click)="downloadQRCode(qr.dataUrl, qr.code)">Download QR</button>
    </div>

  </div>

</div>



<div class="container" *ngIf="Mainapage">
  <h6 class="text-center mb-3 mt-3">
    <b> Register Product</b>
  </h6>

  <!-- <div class="text-center mb-3">
    <img src="assets/papay.jpg" class="product-img" alt="Product">
    <div><strong>Papaya Red Lady</strong></div>
    <small>Serial No: {{ppcode}}</small>
  </div> -->

  <!-- Product Header -->
  <div class="product-header ">
    <img src="assets/papay1-removebg-preview.png" alt="Product">
    <div>
      <span class="text-muted">Papaya Red Lady</span><br>
      <small>Serial No: {{ppcode}}</small>
    </div>
    <!-- <div>
      <span class="text-muted">Papaya Red Lady</span><br>
      <small>Serial No: {{ppcode}}</small>
    </div> -->
  </div>

  <form [formGroup]="orderForm" (ngSubmit)="submitOrder()" class="">

    <input type="hidden" class="" readonly formControlName="productCode" />


    <div class="mb-51">
      <label class=" custom-label text-muted">Name *</label>
      <input class="form-control pt-0" formControlName="customerName" placeholder="Enter your name" />
    </div>

    <div class="mb-51">
      <label class=" custom-label text-muted">Email *</label>
      <input class="form-control pt-0" formControlName="email" placeholder="Enter your email" />
    </div>

    <div class="mb-51">
      <label class=" custom-label text-muted">Phone *</label>
      <input class="form-control pt-0" formControlName="phone" placeholder="Enter your phone number" />
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input rounded-pill" formControlName="agree" formControlName="agree" type="checkbox"
        id="agree" checked required>
      <label for="privacy" class="privacy-text">I agree to <a href="" class="privacy-link">Privacy Policy</a></label>
    </div>

    <button type="submit" [disabled]="orderForm.invalid" class="btn btn-primary w-100 rounded-pill mt-4 bttt">Register
      Product

      <div class="spinner-border text-light sspni" role="status" *ngIf="IsSpenner">
        <span class="sr-only"></span>
      </div>
    </button>

    <!-- <button class="btn btn-primary" (click)="ispresendt()">IS P  </button> -->
  </form>

  <p style="color:green">{{ message }}</p>
</div>

<!-- <div style="padding: 20px;">
  <h2>Bulk QR Code Generator</h2>

  <textarea [(ngModel)]="productCodesText" rows="6" placeholder="Enter product codes separated by comma or newline"
    style="width:100%; padding:10px;"></textarea>
  <button (click)="generateQRCodes()" style="margin-top:10px;">Generate QR Codes</button>

  <div *ngFor="let qr of qrData" style="margin-top:20px;">
    <img [src]="qr.dataUrl" alt="QR Code" style="width:150px; height:150px;">
    <p>{{ baseUrl + qr.code }}</p>
    <button (click)="downloadQRCode(qr.dataUrl, qr.code)">Download QR</button>
  </div>
</div> -->

<!-- <div style="padding: 20px;">
  <h2>Bulk QR Code Generator</h2>

  <textarea [(ngModel)]="productCodesText" rows="6" placeholder="Enter product codes separated by comma or newline"
    style="width:100%; padding:10px;">
  </textarea>

  <div style="margin-top: 10px;">
    <button (click)="generateQRCodes()">Generate QR Codes</button>
    <button (click)="downloadAllAsZip()" [disabled]="!qrData.length">Download All as ZIP</button>
  </div>

  <div *ngFor="let qr of qrData" style="margin-top:20px;">
    <img [src]="qr.dataUrl" alt="QR Code" style="width:150px; height:150px;">
    <p>{{ baseUrl + qr.code }}</p>
    <button (click)="downloadQRCode(qr.dataUrl, qr.code)">Download QR</button>
  </div>
</div> -->